import Home from "@/pages/home.vue";
import User from "@/pages/user.vue";
import VueRouter from "vue-router";

const router = new VueRouter({
  mode: "history",
  routes: [
    { path: "/", redirect: "/home" },
    { path: "/home", component: Home },
    { path: "/user", component: User },
    {
      path: '/threed',
      component: (resolve) => require(['@/pages/three/threed'], resolve),
      name: 'Threed',
      meta: {title: '文物3D'},
      hidden: true,
    },
    {
      path: '/model',
      component: (resolve) => require(['@/pages/model/model'], resolve),
      name: 'Model',
      meta: {title: '文物3D'},
      hidden: true,
    },
    {
      path: '/antique',
      component: (resolve) => require(['@/pages/antique/antique'], resolve),
      name: 'Antique',
      meta: {title: '文物详情'},
      hidden: true,
    }
  ],
});

export default router;
